export const SURVEYS_PER_PAGE = 15;
export const SKELETON_HEIGHT = 41.42;
